import sanityClient from "./sanityClient";

export const MEETUP_GROUP_URL = "https://www.meetup.com/ixda-stavanger";

// The override in Site Configuration wins, otherwise the newest event's link.
// overrideEvent finds the event behind an override link, so the page can show which meetup it is.
// netlify/functions/meetup-click.js makes the same choice when it counts the click.
const query = `{
  "override": *[_type == "siteConfig"][0].meetupLink,
  "newest": *[_type == "event" && defined(eventMeetupNo)] | order(eventMeetupNo desc)[0]{eventMeetupNo, eventName, color, url}
}{
  ...,
  "overrideEvent": *[_type == "event" && defined(^.override) && url == ^.override][0]{eventMeetupNo, eventName, color}
}`;

// Returns { url, event }, where event is null when the link does not belong to an event
export const fetchMeetupTarget = async () => {
  try {
    const { override, newest, overrideEvent } = await sanityClient.fetch(query);

    if (override) return { url: override, event: overrideEvent };
    if (newest?.url) return { url: newest.url, event: newest };
    return { url: MEETUP_GROUP_URL, event: null };
  } catch (error) {
    console.error("Error fetching meetup link:", error);
    return { url: MEETUP_GROUP_URL, event: null };
  }
};
